<template>
  <header>
    <div
      class="border-static-default-mid flex items-center border-b px-12 py-8"
    >
      <RevIllustration
        alt="Backmarket Logo"
        :height="32"
        src="/img/header/logo.svg"
        :width="63"
      />

      <span class="body-1-bold ml-20 hidden md:block">
        {{ i18n(translations.hello, { company: companyName }) }}
      </span>

      <ImpersonatedActions class="ml-20 hidden pt-4 md:block" />

      <div class="flex flex-1 items-center justify-end space-x-12">
        <ClientOnly>
          <RevInputSelect
            id="select-bo-type"
            v-model="currentBoType"
            :label="i18n(translations.selectBoType)"
            :options="Object.values(BO_TYPES)"
            size="small"
            @update:model-value="handleBoTypeChange"
          />

          <TheLanguageSelect />
        </ClientOnly>

        <UserMenu />
      </div>
    </div>

    <TabsSales v-if="currentBoType === BO_TYPES.SALES" />
    <TabsBuyback v-if="currentBoType === BO_TYPES.BUYBACK" />
  </header>
</template>

<script lang="ts" setup>
import { navigateTo, useRoute } from '#imports'
import { ref } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevIllustration } from '@ds/components/Illustration'
import { RevInputSelect, type Value } from '@ds/components/InputSelect'

import { ROUTE_NAMES } from '~/constants/routes'
import { useSellerInfoStore } from '~/scopes/auth/stores/sellerInfoStore'

import translations from './TheHeader.translations'
import ImpersonatedActions from './components/ImpersonatedActions/ImpersonatedActions.vue'
import TabsBuyback from './components/TabsBuyback/TabsBuyback.vue'
import TabsSales from './components/TabsSales/TabsSales.vue'
import UserMenu from './components/UserMenu/UserMenu.vue'

const i18n = useI18n()
const { companyName } = useSellerInfoStore()
const currentRoute = useRoute()

const BO_TYPES = {
  BUYBACK: i18n(translations.boTypeTradeIn),
  SALES: i18n(translations.boTypeSales),
}

const currentBoType = ref(
  currentRoute.matched.some((route) => route.meta.isBuyback)
    ? BO_TYPES.BUYBACK
    : BO_TYPES.SALES,
)

async function handleBoTypeChange(type: Value) {
  const redirectTo =
    type === BO_TYPES.BUYBACK
      ? { name: ROUTE_NAMES.BUYBACK.ORDERS.ACTIVE }
      : { name: ROUTE_NAMES.HOME.INDEX }

  await navigateTo(redirectTo)
}
</script>
